import React, { useEffect } from "react";
import "../../../css/platforms.css";
import shoppingImg from "../../../assets/images/platforms/shopping.png";
import feedingImg from "../../../assets/images/platforms/feeding.png";
import servicesImg from "../../../assets/images/platforms/services.png";
import adashiImg from "../../../assets/images/platforms/adashi.png";
import childcareImg from "../../../assets/images/platforms/childcare.png";
import rentalImg from "../../../assets/images/platforms/rental.png";
import paymentImg from "../../../assets/images/platforms/payment.png";
import travelImg from "../../../assets/images/platforms/travel.png";
import healthcareImg from "../../../assets/images/platforms/healthcare.png";
import { NavLink } from "react-router-dom";
import "../../../css/pages.css";
import TopBtn from "../../buttons/TopBtn";


const PlatformsMain = () => {

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    return () => {};
  }, []);

  return (
    <div className="container" style={{marginTop: "-60px"}}>
      <div id="main" className="">
        <div className="container">
          <section className="tiles">
            <article className="style1">
              <span className="image">
                <img src={shoppingImg} alt="" />
              </span>
              <NavLink to="/pass-shopping">
                <h5>PASS-SHOPPING</h5>
                <div className="content">
                  <p>
                    <b>Shopping before salary...</b>
                  </p>
                </div>
              </NavLink>
            </article>
            <article className="style2">
              <span className="image">
                <img src={feedingImg} alt="" />
              </span>
              <NavLink to="/pass-feeding">
                <h5>PASS-FEEDING</h5>
                <div className="content">
                  <p>
                    <b>Office feeding...</b>
                  </p>
                </div>
              </NavLink>
            </article>
            <article className="style6">
              <span className="image">
                <img src={healthcareImg} alt="" />
              </span>
              <NavLink to="/pass-health">
                <h5>PASS-HEALTH</h5>
                <div className="content">
                  <p>
                    <b>Secure healthy family out of salary...</b>
                  </p>
                </div>
              </NavLink>
            </article>

            <article className="style5">
              <span className="image">
                <img src={rentalImg} alt="" />
              </span>
              <NavLink to="/pass-rentals">
                <h5>PASS-RENTALS</h5>
                <div className="content">
                  <p>
                    <b>Pay rental fees out of salary...</b>
                  </p>
                </div>
              </NavLink>
            </article>
            <article className="style3">
              <span className="image">
                <img src={servicesImg} alt="" />
              </span>
              <NavLink to="/pass-services">
                <h5>PASS-SERVICES</h5>
                <div className="content">
                  <p>
                    <b>In salary services...</b>
                  </p>
                </div>
              </NavLink>
            </article>
            <article className="style4">
              <span className="image">
                <img src={adashiImg} alt="" />
              </span>
              <NavLink to="/pass-adashi">
                <h5>PASS-ADASHI</h5>
                <div className="content">
                  <p>
                    <b>Get valuables/affordable out of salary...</b>
                  </p>
                </div>
              </NavLink>
            </article>
            <article className="style2">
              <span className="image">
                <img src={travelImg} alt="" />
              </span>
              <NavLink to="/pass-travel">
                <h5>PASS-TRAVEL</h5>
                <div className="content">
                  <p>
                    <b>Travel in your salary...</b>
                  </p>
                </div>
              </NavLink>
            </article>
            <article className="style3">
              <span className="image">
                <img src={childcareImg} alt="" />
              </span>
              <NavLink to="/pass-childcare">
                <h5>PASS-CHILD CARE</h5>
                <div className="content">
                  <p>
                    <b>Bright your child Future...</b>
                  </p>
                </div>
              </NavLink>
            </article>
            <article className="style3">
              <span className="image">
                <img src={paymentImg} alt="" />
              </span>
              <NavLink to="/pass-pay">
                <h5>PASS-PAY</h5>
                <div className="content">
                  <p>
                    <b>Pay in your salary...</b>
                  </p>
                </div>
              </NavLink>
            </article>
          </section>
        </div>
      </div>
      <TopBtn />
    </div>
  );
};

export default PlatformsMain;
